/* eslint-disable space-before-blocks */
/* eslint-disable no-console */
/* eslint-disable no-var */
(function($){
    var wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
       * Initialise theme JS on page load
       */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            console.log('%c This website was handcrafted by ❄ WINTER', 'color: #061c2c; display: block; font-size: 20px; font-family: "Muli", sans-serif;');
            console.log('%c Are you a developer? We\'d love to talk to you: inspector@winter.ax', 'color: #061c2c; display: block; font-size: 16px; font-family: "Muli", sans-serif;');
            // eslint-disable-next-line no-console
            console.log('%c www.winter.ax', 'color: #45bcec; display: block; font-size: 14px; font-family: "Muli", sans-serif;');

            // Add a crucial attr to the video tags
            wntrTheme.body.find('video').attr('playsinline', true);

            // Toggle the mobile menu
            wntrTheme.body.find('.header-toggle-mobile .hamburger').on('click', function() {
                $(this).toggleClass('is-active');
                wntrTheme.body.find('.header-toggle-mobile-wrapper').toggleClass('header-active');
                wntrTheme.body.find('.header-nav').fadeToggle();
            });

            // Animate the body
            wntrTheme.body.animate({
                opacity: '1'
            }, 1200, function() {
                // After the video have faded in, we'll play the video
                if(wntrTheme.body.find('.movie-header video').length > 0) {
                    wntrTheme.body.find('.movie-header video').get(0).play();
                }
            });

            // MatchHeight settings
            wntrTheme.body.find('.facebook-post-inner').matchHeight();
            wntrTheme.body.find('.s-link').matchHeight();
            wntrTheme.body.find('.routes-agenda').matchHeight();
            wntrTheme.body.find('.registered-wrapper').matchHeight();
            wntrTheme.body.find('.products li.product .woocommerce-LoopProduct-link').matchHeight();
            wntrTheme.body.find('.registered-inner').matchHeight();
            wntrTheme.body.find('.head-sponsor-link').matchHeight();

            // $.fn.matchHeight._afterUpdate = function(event, groups) {
            //   wntrTheme.body.find('.head-sponsor-link').addClass('center-header-sponsor');
            // }

            if(wntrTheme.body.find('.gform_drop_instructions').length > 0) {
                wntrTheme.body.find('.gform_drop_instructions').html('Or drop files here');
                wntrTheme.body.find('.gform_button_select_files').val('Select files');
            }

            wntrTheme.body.find('.header-desktop-lang').on('mouseenter', function() {
                $(this).find('.header-desktop-languages').addClass('active');
            });

            wntrTheme.body.find('.header-desktop-lang').on('mouseleave', function() {
                $(this).find('.header-desktop-languages').removeClass('active');
            });

            wntrTheme.body.find('.show-more-gallery-images-btn').on('click', function() {
                var gallery_container = $(this).closest('.gallery-by-year');
                gallery_container.find('.hide-images').fadeIn('fast');
                $(this).hide();
            });

            // Autoplay video
            $('.movie-header-fancybox').fancybox({
                helpers: {
                    media: true
                },
                youtube: {
                    autoplay: 1, // enable autoplay
                }
            });

            wntrTheme.body.find('.head-sponsor-inner').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                pauseOnHover: false,
                speed: 750,
                dots: false,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                ]
            });
        }
    };

    $(document).ready(wntrTheme.init);
})(jQuery);
